const isTouchDevice =
  "ontouchstart" in window ||
  navigator.maxTouchPoints > 0 ||
  navigator.msMaxTouchPoints > 0;

document.addEventListener("DOMContentLoaded", () => {
  document.body.classList.add("show");

  let wow = new WOW({
    animateClass: "animated",
  });
  wow.init();

  gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

  if (!isTouchDevice) {
    const scrollTween = gsap.to(".bar", {
      yPercent: 400,
      ease: "none",
      paused: true,
    });

    function updateScrollBar() {
      scrollTween.progress(
        scrollY / (document.body.scrollHeight - innerHeight)
      );
    }
    window.addEventListener("resize", updateScrollBar);
    window.addEventListener("scroll", updateScrollBar);
  } else {
    $(".barContainer").remove();
    $(".cursor").remove();
  }
});

$("document").ready(function () {
  // LOADER
  $({ property: 0 }).animate(
    { property: 100 },
    {
      duration: 2000,
      step: function (now) {},
      complete: function () {
        setTimeout(function () {
          $(".loader").addClass("hide");
          $("body").addClass("loaded");
        }, 500);
      },
    }
  );

  if (!isTouchDevice) {
    ScrollTrigger.normalizeScroll(true);
    var smoother = ScrollSmoother.create({
      smooth: 2,
      effects: true,
      smoothTouch: 5,
    });
  }

  // BANNER ANIMATION
  var tl = gsap.timeline();

  // ON SCROLL ADD CLASS AND REMOVE CLASS
  var a = 0;
  $(window).on("scroll", function () {
    var current_pull = $(window).scrollTop();
    if (current_pull > 100) {
      $("header").addClass("active");
    } else {
      $("header").removeClass("active");
    }
    var a = 1;
  });

  $("#spanYear").html(new Date().getFullYear());

  // SVG IMAGE TO SVG CODE WORKS ON LIVE WEBSITE.
  $(function () {
    jQuery("img.svg").each(function () {
      var $img = jQuery(this);
      var imgID = $img.attr("id");
      var imgClass = $img.attr("class");
      var imgURL = $img.attr("src");
      jQuery.get(
        imgURL,
        function (data) {
          var $svg = jQuery(data).find("svg");
          if (typeof imgID !== "undefined") {
            $svg = $svg.attr("id", imgID);
          }
          if (typeof imgClass !== "undefined") {
            $svg = $svg.attr("class", imgClass + " replaced-svg");
          }
          $svg = $svg.removeAttr("xmlns:a");
          if (
            !$svg.attr("viewBox") &&
            $svg.attr("height") &&
            $svg.attr("width")
          ) {
            $svg.attr(
              "viewBox",
              "0 0 " + $svg.attr("height") + " " + $svg.attr("width")
            );
          }
          $img.replaceWith($svg);
        },
        "xml"
      );
    });
  });

  // LEAF ANIMATIONS
  const leaf1 = document.querySelectorAll(".leaf1");
  const leaf2 = document.querySelectorAll(".leaf2");
  const leaf3 = document.querySelectorAll(".leaf3");
  const leaf4 = document.querySelectorAll(".leaf4");

  leaf1.forEach((item) => {
    tl.to(item, {
      scrollTrigger: {
        trigger: item,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      y: 0,
    });
  });

  leaf2.forEach((item) => {
    tl.to(item, {
      scrollTrigger: {
        trigger: item,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      y: 0,
    });
  });

  leaf3.forEach((item) => {
    tl.to(item, {
      scrollTrigger: {
        trigger: item,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      y: 0,
    });
  });

  leaf4.forEach((item) => {
    tl.to(item, {
      scrollTrigger: {
        trigger: item,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
      y: 0,
    });
  });

  const productCard = document.querySelectorAll(".product--list li");
  tl.to(productCard, {
    scrollTrigger: {
      trigger: productCard,
      start: "top bottom",
      end: "bottom bottom",
      scrub: true,
    },
    stagger: {
      each: 0.05,
      from: 0,
    },
    opacity: 1,
    y: 0,
  });

  if (!isTouchDevice) {
    const uniqueCategoryCard = document.querySelectorAll(".category--list li");
    tl.to(uniqueCategoryCard, {
      scrollTrigger: {
        trigger: uniqueCategoryCard,
        start: "top bottom",
        end: "bottom bottom",
        scrub: true,
      },
      stagger: {
        each: 0.05,
        from: 0,
      },
      opacity: 1,
      y: 0,
    });

    const beautyCard = document.querySelectorAll(".beauty--card");
    tl.to(beautyCard, {
      scrollTrigger: {
        trigger: beautyCard,
        start: "top bottom",
        end: "bottom bottom",
        scrub: true,
      },
      stagger: {
        each: 0.05,
        from: 0,
      },
      opacity: 1,
      y: 0,
    });
  }

  const blogCard = document.querySelectorAll(".blogs li");
  tl.to(blogCard, {
    scrollTrigger: {
      trigger: blogCard,
      start: "top bottom",
      end: "bottom bottom",
      scrub: true,
    },
    stagger: {
      each: 0.05,
      from: 0,
    },
    opacity: 1,
    y: 0,
  });

  if ($(".read--more--box").length) {
    $(".about--kymamai--content--left .link--button").click(function (e) {
      e.preventDefault();
      let content = $(".about--kymamai--content--left .read--more--box");
      if (content.css("max-height") === "0px") {
        let actualHeight = content.prop("scrollHeight") + "px"; // Get actual height
        content.css("max-height", actualHeight);
        $(this).text("< Read Less");
      } else {
        content.css("max-height", "0px");
        $(this).text("Read More >");
      }
    });
  }

  if ($(".unique--category--card .card-body .read--more--box").length) {
    $(".unique--category--card .card-body .link--button").click(function (e) {
      e.preventDefault();

      let content = $(this)
        .closest(".unique--category--card .card-body")
        .find(".read--more--box");

      if (
        content.css("max-height") === "0px" ||
        content.css("max-height") === "none"
      ) {
        let actualHeight = content.prop("scrollHeight") + "px"; // Get actual height
        content.css("max-height", actualHeight);
        $(this).text("< Read Less");
      } else {
        content.css("max-height", "0px");
        $(this).text("Read More >");
      }
    });
  }

  if ($(".responsible--beauty--content .card-body .read--more--box").length) {
    $(".responsible--beauty--content .card-body .link--button").click(function (
      e
    ) {
      e.preventDefault();

      let content = $(this)
        .closest(".responsible--beauty--content .card-body")
        .find(".read--more--box");

      if (
        content.css("max-height") === "0px" ||
        content.css("max-height") === "none"
      ) {
        let actualHeight = content.prop("scrollHeight") + "px"; // Get actual height
        content.css("max-height", actualHeight);
        $(this).text("< Read Less");
      } else {
        content.css("max-height", "0px");
        $(this).text("Read More >");
      }
    });
  }

  if ($(".read--more--box").length) {
    $(".our--story .link--button").click(function (e) {
      e.preventDefault();
      let content = $(".our--story .read--more--box");
      if (content.css("max-height") === "0px") {
        let actualHeight = content.prop("scrollHeight") + "px"; // Get actual height
        content.css("max-height", actualHeight);
        $(this).text("< Read Less");
      } else {
        content.css("max-height", "0px");
        $(this).text("Read More >");
      }
    });
  }
  if ($(".read--more--box").length) {
    $(".philosophy .link--button").click(function (e) {
      e.preventDefault();
      let content = $(".philosophy .read--more--box");
      if (content.css("max-height") === "0px") {
        let actualHeight = content.prop("scrollHeight") + "px"; // Get actual height
        content.css("max-height", actualHeight);
        $(this).text("< Read Less");
      } else {
        content.css("max-height", "0px");
        $(this).text("Read More >");
      }
    });
  }

  if ($(".read--more--box").length) {
    $(".founder--message .link--button").click(function (e) {
      e.preventDefault();
      let content = $(".founder--message .read--more--box");
      if (content.css("max-height") === "0px") {
        let actualHeight = content.prop("scrollHeight") + "px"; // Get actual height
        content.css("max-height", actualHeight);
        $(this).text("< Read Less");
      } else {
        content.css("max-height", "0px");
        $(this).text("Read More >");
      }
    });
  }
  if ($(".read--more--box").length) {
    $(".awards .link--button").click(function (e) {
      e.preventDefault();
      let content = $(".awards .read--more--box");
      if (content.css("max-height") === "0px") {
        let actualHeight = content.prop("scrollHeight") + "px"; // Get actual height
        content.css("max-height", actualHeight);
        $(this).text("< Read Less");
      } else {
        content.css("max-height", "0px");
        $(this).text("Read More >");
      }
    });
  }

  if ($(".read--more--box").length) {
    $(".introduction--section .link--button").click(function (e) {
      e.preventDefault();
      let content = $(".introduction--section .read--more--box");
      if (content.css("max-height") === "0px") {
        let actualHeight = content.prop("scrollHeight") + "px"; // Get actual height
        content.css("max-height", actualHeight);
        $(this).text("< Read Less");
      } else {
        content.css("max-height", "0px");
        $(this).text("Read More >");
      }
    });
  }
});

var customerReviewSlider = new Swiper(".customer--review--slider", {
  slidesPerView: 3,
  spaceBetween: 20,
  loop: true,
  speed: 1000,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  navigation: {
    nextEl: ".customer--reviews .swiper-button-next",
    prevEl: ".customer--reviews .swiper-button-prev",
  },
});

var customerReviewSlider = new Swiper(".product--gallery--slider", {
  slidesPerView: 4.1,
  spaceBetween: 20,
  loop: true,
  speed: 10000,
  autoplay: {
    delay: 0,
    disableOnInteraction: false,
  },
});

if ($(".gallery--list").length) {
  const listItems = document.querySelectorAll(".gallery--list .img-box");
  listItems.forEach((i) => {
    gsap.to(
      i,
      {
        scrollTrigger: {
          trigger: i,
          scrub: true,
          start: "top 95%",
          // markers: true,
        },
        duration: 2.5,
        ease: "elastic.out(1, 0.75)",
        opacity: 1,
        scale: 1,
      },
      1
    );
  });
}

document.addEventListener('DOMContentLoaded', function() {
    const toggleCategory = document.getElementById('toggle-category');
    const categoryList = document.getElementById('category-list');

    toggleCategory.addEventListener('click', function() {
        // Toggle the open class on the span and the list
        toggleCategory.classList.toggle('open');
        categoryList.classList.toggle('open');
    });
});
